import { PumpSuspendReason } from "@tandemdiabetes/sugarmate-api-react-client"
import type { PumpSuspensionActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"
import { usePolyglot } from "src/contexts"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: PumpSuspensionActivity;
}

const prefix = "components.activity_summary.title.pump_suspension."

export const PumpSuspensionActivityTitle = forwardRef<HTMLDivElement, Props>(
  function PumpSuspensionActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity, ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    const title = useMemo(
      () => {
        switch (activity.suspend_reason) {
          case PumpSuspendReason.BIQSuspend:
            return polyglot.t(`${prefix}biq`)
          case PumpSuspendReason.CIQSuspend:
            return polyglot.t(`${prefix}ciq`)
          default:
            return polyglot.t(`${prefix}default`)
        }
      },
      [
        activity.suspend_reason,
        polyglot,
      ],
    )

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {title}
      </div>
    )
  },
)
